import { render, staticRenderFns } from "./type_2.vue?vue&type=template&id=2d58cf5e&scoped=true"
import script from "./type_2.vue?vue&type=script&lang=js"
export * from "./type_2.vue?vue&type=script&lang=js"
import style0 from "./type_2.vue?vue&type=style&index=0&id=2d58cf5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d58cf5e",
  null
  
)

export default component.exports